'use client';
import Head from 'next/head';
import '@/lib/env';

import useLandingPage from '@/lib/hooks/useLandingPage';

import CallToAction from '@/app/components/LandingPage/CallToAction';
import ExampleSketches from '@/app/components/LandingPage/ExampleSketches';
import Faq from '@/app/components/LandingPage/FAQ';
import Footer from '@/app/components/LandingPage/Footer';
import Hero from '@/app/components/LandingPage/Hero';
import HowItWorksMerch from '@/app/components/LandingPage/HowItWorksMerch';
import Navbar from '@/app/components/LandingPage/NavigationBar';
import SectionTitle from '@/app/components/LandingPage/SectionTitle';
import TwitterFeed from '@/app/components/LandingPage/TwitterFeed';
import { callToActionInputTShirt } from '@/constant/LandingPage/callToAction';
import { exampleSketchesTShirt } from '@/constant/LandingPage/exampleSketches';
import { faqdataTShirt } from '@/constant/LandingPage/faq';
import { tShirtLpConfig } from '@/constant/LandingPage/hero';
import { menusTShirt } from '@/constant/LandingPage/menus';

export default function TShirtLandingPage() {
  const handleUnderRepair = useLandingPage();

  return (
    <main>
      <Head>
        <title>SketchMe.App</title>
      </Head>
      <Navbar handleUnderRepair={handleUnderRepair} menus={menusTShirt} />
      <Hero lpConfig={tShirtLpConfig} handleUnderRepair={handleUnderRepair} />
      <SectionTitle
        pretitle='Examples'
        title='Your Beloved Photos turn into Unique T-Shirt Designs.'
        id='examples'
      />
      <ExampleSketches exampleSketches={exampleSketchesTShirt} />
      <SectionTitle pretitle='How it Works' id='how-it-works' />
      <HowItWorksMerch />
      <SectionTitle
        pretitle='Customers'
        title='Many of our Users have Shared their T-Shirts on Social Media!'
        id='customers'
      />
      <TwitterFeed />
      <SectionTitle
        pretitle='FAQ'
        title='Frequently Asked Questions'
        id='faq'
      />
      <Faq faqdata={faqdataTShirt} />
      <CallToAction
        handleUnderRepair={handleUnderRepair}
        callToActionInput={callToActionInputTShirt}
      />
      <Footer />
    </main>
  );
}
